<mat-form-field class="chip-list" appearance="fill">
  <mat-label>Narrators</mat-label>
  <mat-chip-grid #currentNarratorList>
    @for(narrator of narrators(); track narrator) {
    <mat-chip-row [removable]="removable" (removed)="remove(narrator)" color="primary">
      {{ narrator }}
      @if(removable){
      <mat-icon matChipRemove>cancel</mat-icon>
      }
    </mat-chip-row>
    }
    <input #narratorInput [formControl]="narratorCtrl" [matAutocomplete]="auto" [matChipInputFor]="currentNarratorList"
      [matChipInputSeparatorKeyCodes]="separatorKeysCodes" [matChipInputAddOnBlur]="addOnBlur"
      (matChipInputTokenEnd)="add($event)" />
  </mat-chip-grid>
  <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)">
    @for (name of (filteredNames | async); track name ) {
    <mat-option [value]="name">
      {{ name }}
    </mat-option>
    }
  </mat-autocomplete>
</mat-form-field>